import React, { useState } from 'react';

function HiraTechPKExpenses() {
  const [expenses, setExpenses] = useState([]);
  const [title, setTitle] = useState('');
  const [amount, setAmount] = useState('');
  const [date, setDate] = useState('');

  const handleAddExpense = (e) => {
    e.preventDefault();
    if (title && amount && date) {
      const newExpense = { id: Date.now(), title, amount: parseFloat(amount), date };
      setExpenses([...expenses, newExpense]);
      setTitle('');
      setAmount('');
      setDate('');
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      padding: '40px 20px',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    }}>
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        backgroundColor: '#ffffff',
        borderRadius: '15px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
        padding: '30px',
      }}>
        <h1 style={{
          fontSize: '2.5rem',
          color: '#2c3e50',
          textAlign: 'center',
          marginBottom: '30px',
          fontWeight: '600',
        }}>
          Hira Tech PK Expense Tracker
        </h1>

        {/* Add Expense Form */}
        <div style={{
          backgroundColor: '#f8f9fa',
          padding: '25px',
          borderRadius: '10px',
          marginBottom: '30px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
        }}>
          <h2 style={{
            fontSize: '1.5rem',
            color: '#34495e',
            marginBottom: '20px',
            fontWeight: '500',
          }}>
            Add New PK Expense
          </h2>
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '20px',
          }}>
            <input
              type="text"
              placeholder="Expense Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              style={{
                flex: '1 1 200px',
                padding: '12px',
                fontSize: '1rem',
                border: '1px solid #dcdcdc',
                borderRadius: '8px',
                outline: 'none',
                transition: 'border-color 0.3s ease',
              }}
            />
            <input
              type="number"
              placeholder="Amount"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              style={{
                flex: '1 1 200px',
                padding: '12px',
                fontSize: '1rem',
                border: '1px solid #dcdcdc',
                borderRadius: '8px',
                outline: 'none',
                transition: 'border-color 0.3s ease',
              }}
            />
            <input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              style={{
                flex: '1 1 200px',
                padding: '12px',
                fontSize: '1rem',
                border: '1px solid #dcdcdc',
                borderRadius: '8px',
                outline: 'none',
                transition: 'border-color 0.3s ease',
              }}
            />
            <button
              onClick={handleAddExpense}
              style={{
                flex: '1 1 100px',
                padding: '12px',
                fontSize: '1rem',
                backgroundColor: '#3498db',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'background-color 0.3s ease',
              }}
            >
              Add Expense
            </button>
          </div>
        </div>

        {/* Expense List */}
        <div>
          <h2 style={{
            fontSize: '1.5rem',
            color: '#34495e',
            marginBottom: '20px',
            fontWeight: '500',
          }}>
            PK Expense List
          </h2>
          {expenses.length === 0 ? (
            <p style={{
              color: '#7f8c8d',
              fontSize: '1rem',
              textAlign: 'center',
            }}>
              No PK expenses added yet.
            </p>
          ) : (
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '15px',
            }}>
              {expenses.map((expense) => (
                <div
                  key={expense.id}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '15px',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '8px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                    transition: 'transform 0.2s ease',
                  }}
                >
                  <div style={{ flex: '1' }}>
                    <p style={{
                      margin: '0',
                      fontSize: '1.1rem',
                      color: '#2c3e50',
                      fontWeight: '500',
                    }}>
                      {expense.title}
                    </p>
                    <p style={{
                      margin: '0',
                      fontSize: '0.9rem',
                      color: '#7f8c8d',
                    }}>
                      {new Date(expense.date).toLocaleDateString()}
                    </p>
                  </div>
                  <div style={{
                    fontSize: '1.1rem',
                    color: expense.amount < 0 ? '#e74c3c' : '#2ecc71',
                    fontWeight: '600',
                  }}>
                    ₨{Math.abs(expense.amount).toFixed(2)}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default HiraTechPKExpenses;